export function parseMessyNumber(value) {
	if (typeof value === 'number') return value
	if (value === '-' || value === '') return 0
	const str = value.trim()
	const hasComma = str.includes(',')
	const hasDot = str.includes('.')

	if (hasComma && hasDot) {
		const lastComma = str.lastIndexOf(',')
		const lastDot = str.lastIndexOf('.')
		if (lastDot > lastComma) {
			// EN: 1,000.50
			return parseFloat(str.replace(/,/g, ''))
		} else {
			// ES: 1.000,50
			return parseFloat(str.replace(/\./g, '').replace(',', '.'))
		}
	}

	if (hasComma) {
		const parts = str.split(',')
		if (parts.length === 2 && parts[1].length <= 2) {
			// 1,50 → decimal
			return parseFloat(str.replace(',', '.'))
		}
		if (
			parts.length === 2 &&
			parts[0].length > 0 &&
			parts[1].length === 3
		) {
			// 1,000 → thousands
			return parseFloat(str.replace(/,/g, ''))
		}
		// fallback
		return parseFloat(str.replace(',', '.'))
	}

	if (hasDot) {
		const parts = str.split('.')
		if (parts.length === 2 && parts[1].length <= 2) {
			// 1.50 → decimal
			return parseFloat(str)
		}
		if (
			parts.length === 2 &&
			parts[0].length > 0 &&
			parts[1].length === 3
		) {
			// 1.000 → thousands
			return parseFloat(str.replace(/\./g, ''))
		}
		// fallback
		return parseFloat(str)
	}

	// No separator
	return parseFloat(str)
}

export function roundAtDecimals(number, decimalsToRound) {
	if (!number) return 0
	number = parseMessyNumber(number)
	const roundedNumber =
		Math.round(number * Math.pow(10, decimalsToRound)) /
		Math.pow(10, decimalsToRound)
	if (countDecimals(roundedNumber))
		return Number(roundedNumber.toFixed(decimalsToRound))

	return roundedNumber
}

export function countDecimals(number) {
	if (Math.floor(number) === number) return 0
	return (number.toString && number.toString().split('.')[1]?.length) || 0
}

export function roundCurrency(number) {
	// Si el valor es null, devuelve '0,00'
	if (number == null) return ''

	// Si el valor es un string y no es un número válido, devuelve el string original
	if (typeof number === 'string' && isNaN(Number(number))) {
		return number
	}

	// Convierte el valor a un número
	const numericValue = Number(number)

	// Si el valor no es un número válido, devuelve '0,00'
	if (isNaN(numericValue)) return ''

	// Redondear el número a dos decimales
	const roundedNumber = Math.round(numericValue * Math.pow(10, 2)) / Math.pow(10, 2)

	// Formatear el número redondeado
	let formattedNumber = roundedNumber.toFixed(2)

	// Dividir el número en parte entera y parte decimal
	const parts = formattedNumber.split('.')

	// Aplicar el formato de separadores de miles a la parte entera
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')

	// Unir la parte entera y la parte decimal con una coma
	formattedNumber = parts.join(',')

	return formattedNumber
}

export function calculateVolumetricWeight(x, y, z) {
	const EXTRA_VOLUMETRIC_SIZE_BY_PACKAGING = 1.2
	const VOLUMETRIC_WEIGHT_CONSTANT = 5000
	//convert from milimeters to centimeters
	x = x / 10
	y = y / 10
	z = z / 10
	const volumetricSize = (x * y * z) * EXTRA_VOLUMETRIC_SIZE_BY_PACKAGING
	return volumetricSize / VOLUMETRIC_WEIGHT_CONSTANT
}

export function isEven(number) {
	return number % 2 === 0
}

export function formatWeight(orderWeight) {
	if (orderWeight && orderWeight > 1000) {
		return `${roundAtDecimals(orderWeight / 1000, 1)} kg`
	} else {
		return `${roundAtDecimals(orderWeight, 0)} g`

	}
}

// IT ROUNDS 0,5 example 1,3 -> 1,5 || 0,7 -> 1
export const roundIntrastatWeight = (weight) => {
	return Math.ceil(weight / 1000 * 2) / 2
}
// 1234567890 -> '1.234.567.890'
export function formatNumberWithDots(number) {
	let numStr = number.toString()
	numStr = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
	return numStr
}

export const formatCurrencyWithSeparators = (number) => {
	const numberString = number.toFixed(2)
	const splitNumber = numberString.split('.')
	const integerPart = splitNumber[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
	const decimalPart = splitNumber[1]
	return `${integerPart},${decimalPart}`
}

export const formatNumber = (number) => {
	if (number == null) return '0'
	if (typeof number === 'string' && isNaN(Number(number))) {
		return number
	}
	const numericValue = Number(number)
	if (isNaN(numericValue)) return '0'
	let formattedNumber = numericValue.toFixed(2)
	const parts = formattedNumber.split('.')
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
	if (Math.floor(numericValue) === numericValue) {
		formattedNumber = parts[0]
	} else {
		formattedNumber = parts.join(',')
	}
	return formattedNumber
}
